import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import {AttributeValueHandler} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class TodayAttributeValueHandler implements AttributeValueHandler {
  readonly key = 'TODAY';
  readonly handle = () => formatDate(Date.now(), 'yyyy-MM-dd', 'en-us');
}


